export default{
  getUrnIndex(state){
    return state.urnIndex
  },
  getUrnMetadata(state){
    return state.urnMetadata
  }
}
